module.exports = __webpack_public_path__ + "static/media/newMyCenterBG.39bff127.png";